<template>
  <div class="bm-invitation" >
    <div class="title" >
      邀请球队
    </div>
    <p>你可以分享邀请页面到微信或QQ,队长或球对管理者提交球队报名; 你可以进入报名球队页面审核球队是否参赛。</p>
    <div class="block" >
      <div class="line" ></div>
      <ul>
        <li>分享邀请页面</li>
        <li>球队报名</li>
        <li>审核球队</li>
      </ul>
    </div>
    <!--<router-link :to="'/invite/team?matchId=' + this.query.matchId" style="color: red;" >用于链接分享做调试，上线请务必删除</router-link>-->
    <div class="foot" @click="share()" >
      <a>
        邀请球队
      </a>
    </div>

    <!-- 引导页弹窗 -->

    <van-popup class="guidePopup" v-model="isShowGuidePopup">
      <img src="@/assets/images/guide.png">
    </van-popup>

  </div>
</template>

<script>
import Vue from 'vue'
import { ImageFormat, formatDate, AppType } from '@/utils'
import { getMatchInfo } from '@/api/match'
import { Toast, Popup } from 'vant'
import { callShare } from '@/libs/ds-bridge'
import { updateBMMatchSignUpRule } from '@/api/team'

Vue.use(Toast).use(Popup)

export default {
  name: 'invitation',
  data () {
    return {
      query: this.$route.query,
      isShowGuidePopup: false,
      data: null,
      shareData: {}
    }
  },
  created() {
    this.getMatchInfo()
  },
  methods: {
    getMatchInfo: function() {
      getMatchInfo(this.query.matchId).then(response => {
        const data = this.data = response.data
        const url = this.getShareLink()
        const regEndDate = data.match.regEndDate
        let sharName = data.match.chineseName ? data.match.chineseName : data.match.chineseFullName
        let abstract = '赛事报名'
        if (regEndDate) {
          abstract = abstract + '-' + formatDate(regEndDate)
        }
        this.shareData = {
          title: sharName,
          link: url,
          image: ImageFormat.squareImageView(data.match.icon, 120),
          abstract: abstract
        }
        this.wxShare(this.shareData)
      })
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/invite/team?dsbridge=1&matchId=' + this.query.matchId
    },
    share() {
      let url = this.getShareLink()
      let abstract = '赛事报名'
      const regEndDate = this.data.match.regEndDate
      let sharName = this.data.match.chineseName ? this.data.match.chineseName : this.data.match.chineseFullName
      if (regEndDate) {
        abstract = abstract + '-' + formatDate(regEndDate)
      }
      let share = {
        title: sharName,
        desc: abstract,
        link: url,
        imgUrl: ImageFormat.squareImageView(this.data.match.icon, 120)
      }
      this.updateBMMatchSignUpRule() // 产品需求 背后逻辑 强行打开 赛事方可接受报名。
      if (AppType.isInApp()) {
        callShare(share)
      } else {
        this.isShowGuidePopup = true
      }
    },
    updateBMMatchSignUpRule() {
      let params = {
        matchId: this.query.matchId,
        allowTeamSignup: 1
      }
      updateBMMatchSignUpRule(params).then(response => {})
    }
  }
}
</script>

<style lang="stylus">
.bm-invitation
  height: 100%
  position relative
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  .title+p
    font-size:16px;
    font-weight:300;
    color:rgba(0,0,0,1);
    line-height:22px;
    padding: 0 15px;
    margin: 0;
  .block
    padding: 15px 15px 15px 40px;
    font-size:20px;
    font-weight:300;
    color:rgba(0,0,0,1);
    position relative
    ul
      li
        padding: 5px 0;
  .line
    position absolute
    width 2px
    height calc(100% - 50px)
    left 20px
    top: 50%
    transform translate(0, -50%)
    background-color #32A377
  .line::before
    content ""
    position absolute
    width 15px
    height 15px
    border-radius 50px
    background-color #32A377
    left: -7.5px;
    box-shadow 0 40px 0 #32A377, 0 80px 0 #32A377;
  .foot
    padding: 10px 0
    background: rgba(250,250,250,1);
    color: #32A377
    font-size 20px
    text-align center
    position absolute
    bottom: 0
    width: 100%
    a
      color: #32A377
      font-size: 20px
  .guidePopup
    background-color transparent
    width calc(100% - 100px)
    max-width: 480px
    top: 0px
    transform: translate3d(-50%,0%,0);
    img
      width 100%
</style>



// WEBPACK FOOTER //
// src/pages/invite/invitation.vue